// extracted by mini-css-extract-plugin
var _1 = "SidebarSectionsModal-module__actionContainer--uHI1G";
var _2 = "SidebarSectionsModal-module__active--XFNdy";
var _3 = "SidebarSectionsModal-module__addItemContainer--HXp3f";
var _4 = "SidebarSectionsModal-module__animateUploadProgressBarWidth--h_73B";
var _5 = "SidebarSectionsModal-module__animatedBackground--TL3pp";
var _6 = "SidebarSectionsModal-module__body--_Zx3D";
var _7 = "SidebarSectionsModal-module__buttons--HHdFL";
var _8 = "SidebarSectionsModal-module__container--KLuN0";
var _9 = "SidebarSectionsModal-module__controls--Xn74_";
var _a = "SidebarSectionsModal-module__createSectionButton--rfVLE";
var _b = "SidebarSectionsModal-module__createSectionButtonContainer--nsYlo";
var _c = "SidebarSectionsModal-module__deleteSectionButton--Nb99V";
var _d = "SidebarSectionsModal-module__emptyStateMessage--p2aBa";
var _e = "SidebarSectionsModal-module__footer--vxk5j";
var _f = "SidebarSectionsModal-module__header--yt_rN";
var _10 = "SidebarSectionsModal-module__infoIconContainer--LMAWH";
var _11 = "SidebarSectionsModal-module__innerContainer--exwsd";
var _12 = "SidebarSectionsModal-module__nameField--aGlJi";
var _13 = "SidebarSectionsModal-module__overflowMenuButton--GMZv4";
var _14 = "SidebarSectionsModal-module__saveButton--uNjb1";
var _15 = "SidebarSectionsModal-module__scrollablePane--TyeIe";
var _16 = "SidebarSectionsModal-module__sectionTypeSelect--m34Xr";
var _17 = "250px";
var _18 = "SidebarSectionsModal-module__text--Yq1Bp";
export { _1 as "actionContainer", _2 as "active", _3 as "addItemContainer", _4 as "animateUploadProgressBarWidth", _5 as "animatedBackground", _6 as "body", _7 as "buttons", _8 as "container", _9 as "controls", _a as "createSectionButton", _b as "createSectionButtonContainer", _c as "deleteSectionButton", _d as "emptyStateMessage", _e as "footer", _f as "header", _10 as "infoIconContainer", _11 as "innerContainer", _12 as "nameField", _13 as "overflowMenuButton", _14 as "saveButton", _15 as "scrollablePane", _16 as "sectionTypeSelect", _17 as "sidebarWidth", _18 as "text" }
